import React from 'react';
import { FormattedMessage } from 'react-intl';
import { assetPrefix } from '../../../../../utils';
import { Button, Image } from '@chakra-ui/react';

export const DecisionTreeResultCtaDivorce: React.FC = () => {
  //const { questions } = useContext(DecisionTreeContext);

  /*const getLink = (questions: DecisionTreeQuestion[]) => {
    const hasConvenantQuestionWithAnswerJa = questions.find(
      (question) => question.id === 6 && question.answer?.answer === 'Ja'
    );

    return hasConvenantQuestionWithAnswerJa
      ? '/afspraak-maken-relatiebreuk'
      : '/afspraak-maken-relatiebreukmediation';
  };*/

  const link = '/afspraak-maken-relatiebreuk';

  return (
    <div className={`mb-8 md:mb-0`}>
      <Image
        className={`w-full max-w-[400px]`}
        src={`${assetPrefix}/assets/decision-tree/divorce/images/cta-result.png`}></Image>
      <h2>
        <FormattedMessage id={`cta.divorce.header`} defaultMessage={'Jullie volgende stap'} />
      </h2>
      <div>
        <FormattedMessage
          id={`cta.divorce.text`}
          defaultMessage={`De Hypotheker kan jou en je ex-partner helpen om de scheiding/relatiebreuk zo goed mogelijk te laten verlopen. Onze hypotheekadviseurs en/of mediators helpen je graag verder. Maak een afspraak bij onze vestiging bij jou in de buurt.`}
        />
      </div>

      <Button className={`mt-8`} colorScheme={`orange`} as={`a`} href={link}>
        Afspraak maken
      </Button>
    </div>
  );
};
